// extracted by mini-css-extract-plugin
export var label = "_ek-5";
export var slideContainer = "_ek-0";
export var slider = "_ek-1";
export var sliderLg = "_ek-4";
export var sliderMd = "_ek-3";
export var sliderSm = "_ek-2";